import { Component, Input } from '@angular/core';

import { Location } from '@recruitee/http-types';
import { I18nService, TranslatePipe } from '@recruitee/i18n';
import { IconComponent, RtTooltip } from '@recruitee/user-interface';

@Component({
  standalone: true,
  selector: 'rtr-locations-info',
  templateUrl: './offer-locations-info.component.html',
  imports: [IconComponent, RtTooltip, TranslatePipe],
})
export class OfferLocationsInfoComponent {
  @Input({ required: true }) public locations: Location[];

  public locationNames: string[];
  private readonly translations = {
    archived: this.i18n.translate('rtr.job_details.archived'),
  };

  constructor(private i18n: I18nService) {}

  public ngOnChanges(): void {
    this.locationNames =
      this.locations.map(location =>
        location.archivedAt ? `${location.name} (${this.translations.archived})` : location.name,
      ) || [];
  }
}
